import React, { useEffect } from 'react';

const ListResponse = ({ list, question, selectQuestion, scrollbarRef, scrollPosition }) => {
    useEffect(() => { // Mantenemos la posicion del scroll al hacer clic en otra pregunta
        const scrollContainer = scrollbarRef?.current?.scrollerElement;
        if (scrollContainer) {
            scrollContainer.scrollTop = scrollPosition;
        }
    }, [scrollPosition]);

    return (
        <ul className='list-unstyled mx-lg-3 mb-0'>
            {(list && list.length > 0) && (
                list.map(([key, item, nodeRef], index) => (
                    <li key={item?.item_id} ref={nodeRef}>
                        <div className='d-flex align-items-center py-2 px-3 px-lg-0 border-bottom cursor-pointer' onClick={() => selectQuestion(item.item_id)}>
                            <div className={`p-2 mr-3 rounded-circle border border-${item?.value_name} bg-${item?.value_name === 'sometimes' ? 'transparent' : item?.value_name}`}>
                                <img src={item?.icon_invert} className="d-block" width="30" height="30" alt={item?.name} />
                            </div>
                            <div>
                                <p className='mb-0 font-weight-semibold'>{item?.name}</p>
                                <p className="text-muted description">{item?.description}</p>
                            </div>
                            <div className='ml-auto'>
                                <p className='mb-0 text-muted small font-weight-medium text-capitalize'>{item?.value_name}</p>
                            </div>
                        </div>
                    </li>
                ))
            )}
            <li className='current-question-li bg-ice-60 w-100 cursor-pointer' onClick={() => selectQuestion('lastUnaswered')}>
                <div className='d-flex align-items-center py-2 px-3 px-lg-0'>
                    <div className='p-2 mr-3 rounded-circle'>
                        <img src={question.icon_invert} className='d-block' width="30" height="30" alt={question.name} />
                    </div>
                    <div><p className='mb-0 font-weight-semibold'>{question.name}</p></div>
                </div>
            </li>
        </ul>
    );
};

export default ListResponse;